import React from 'react';
import UserCard from './UserCard';
import LoadingSpinner from '../shared/LoadingSpinner';

/**
 * Component to return the card grid. This takes in the array of users and generates an array of cards
 * @param {array} props.users - The array of users to be displayed
 */

function UnconnectedUserListCards(props) {
  const { users } = props;

  function userCards() {
    const cardsDisplay = users.map((user) => {
      return (
        <UserCard
          userId={user.id}
          key={user.id}
          location={props.location}
          data-test="user-card"
        />
      );
    });

    if (cardsDisplay.length > 0 || props.apiSpinner.usersReturned) {
      return cardsDisplay;
    } else {
      return (
        <div className="loading-spinner__user-list-container">
          <LoadingSpinner />
        </div>
      );
    }
  }

  return (
    <div className="users-list__user-list-container-cards">{userCards()}</div>
  );
}

export default UnconnectedUserListCards;
